import { render } from "./Donut.vue?vue&type=template&id=4f1884e4&scoped=true"
import script from "./Donut.vue?vue&type=script&lang=js"
export * from "./Donut.vue?vue&type=script&lang=js"

import "./Donut.vue?vue&type=style&index=0&id=4f1884e4&scoped=true&lang=css"
import "./Donut.vue?vue&type=style&index=1&id=4f1884e4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f1884e4"]])

export default __exports__